var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "payment_entry"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "支払方法登録", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "text-start" }, [
    /*#__PURE__*/ _createElementVNode("h4", { style: { "text-align": "start" } }, "現在ご登録されているクレジットカード")
], -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", null, "カード番号", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("dt", null, "有効期限", -1);
const _hoisted_10 = { class: "" };
const _hoisted_11 = {
    key: 0,
    style: { "margin-top": "40px", "padding": "20px 40px", "border": "solid 1px red" }
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { style: { "color": "red", "font-size": "19px", "margin": "40px 0px" } }, " 今月の月額料金のカード決済に失敗したため、下のポタンから決済を完了してください。 カードが利用不可の場合には、カードの変更をご検討ください。 ", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_14 = {
    id: "payment-cancel-modal",
    class: "modal"
};
const _hoisted_15 = { class: "modal-content" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("h2", null, " 有料会員申請中でキャンセルすると無料会員で登録されますがよろしいでしょうか？ ", -1);
import { inject, ref, reactive, computed, onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
import StripeForm from '@component/PaymentForm.vue';
import ImageFrame from '@component/ImageFrame.vue';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
import { QuestionType } from '@util/Consts';
export default /*#__PURE__*/ _defineComponent({
    __name: 'payment_entry',
    props: {
        common: null,
        payment: null,
        planId: null,
        plan_id: null,
        card_id: null,
        create_question_available: { type: Boolean },
        payment_intent_client_secret: null
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const props = __props;
        const auth_3ds_complete = ref('loading');
        const form = reactive({
            payment_card_number: (_b = (_a = props.payment) === null || _a === void 0 ? void 0 : _a.payment_card_number) !== null && _b !== void 0 ? _b : '',
            payment_card_brand: (_d = (_c = props.payment) === null || _c === void 0 ? void 0 : _c.payment_card_brand) !== null && _d !== void 0 ? _d : '',
            payment_card_expire_month: (_f = (_e = props.payment) === null || _e === void 0 ? void 0 : _e.payment_card_expire_month) !== null && _f !== void 0 ? _f : '',
            payment_card_expire_year: (_h = (_g = props.payment) === null || _g === void 0 ? void 0 : _g.payment_card_expire_year) !== null && _h !== void 0 ? _h : '',
        });
        const paymentCanceled = ref();
        const stripeBtn = ref();
        const showLimitDate = computed(() => {
            const month = form.payment_card_expire_month;
            const year = form.payment_card_expire_year;
            if (month && year) {
                return Formatter.formatDate(`${year}/${month}/01`, 'MM/YYYY');
            }
            return '未登録';
        });
        const isCardExpired = () => {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1; // getMonth is zero-based; January is 0!
            const currentYear = currentDate.getFullYear();
            const cardExpireYear = parseInt(form.payment_card_expire_year);
            const cardExpireMonth = parseInt(form.payment_card_expire_month);
            // Check if the card is expired by comparing the current year and month with the card's expiration year and month
            return (cardExpireYear < currentYear ||
                (cardExpireYear === currentYear && cardExpireMonth < currentMonth));
        };
        const showCardNumber = computed(() => {
            if (!form.payment_card_number) {
                return '未登録';
            }
            if (form.payment_card_brand) {
                return `${form.payment_card_brand} 末尾 ${form.payment_card_number}`;
            }
            else {
                return `末尾 ${form.payment_card_number}`;
            }
        });
        const onCompleted = (value) => {
            form.payment_card_number = value.payment_card_number;
            form.payment_card_brand = value.payment_card_brand;
            form.payment_card_expire_month = value.payment_card_expire_month;
            form.payment_card_expire_year = value.payment_card_expire_year;
        };
        const onClickRegisterComplete = () => {
            Inertia.get(route('questioner.register.complete'));
        };
        const onCancel = () => {
            if (props.planId && !props.payment) {
                paymentCanceled.value.click();
            }
        };
        const onClickCancel = () => {
            document.getElementById('payment-cancel-modal').style.display = 'none';
            stripeBtn.value.click();
        };
        const onClickMainPlanPay = () => {
            if (props === null || props === void 0 ? void 0 : props.card_id) {
                // Check if the card is expired before proceeding
                if (isCardExpired()) {
                    swal({
                        title: "確認",
                        text: "クレジットカード決済できませんでした。必要により別カードの登録をご検討ください。",
                        icon: "warning",
                        buttons: {
                            ok: {
                                text: "OK",
                                className: "timeout-ok-btn",
                            },
                        },
                    });
                    return;
                }
                const message = '即時課金されますがよろしいでしょうか？';
                if (!window.confirm(message))
                    return;
            }
            Inertia.post(route('payment.main_plan_pay'), { plan_id: props.plan_id }, {
                onSuccess: () => {
                },
                onError: (errors) => {
                    // Assuming 'errors' is part of the component's data
                    if (errors.message) {
                        swal({
                            title: "確認",
                            text: "クレジットカード決済できませんでした。必要により別カードの登録をご検討ください。",
                            icon: "warning",
                            buttons: {
                                ok: {
                                    text: "OK",
                                    className: "timeout-ok-btn",
                                },
                            },
                        });
                    }
                    else {
                        // Fallback error message
                        alert("お支払いの処理中にエラーが発生しました。\nしばらく時間をおいてアクセスしてみてください。");
                    }
                },
            });
        };
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            const publishableKey = inject('stripePublicKey');
            const secretKey = inject('stripeSecretKey');
            const stripePromise = loadStripe(publishableKey);
            const stripe = yield stripePromise;
            if (props.payment_intent_client_secret) {
                const payment_intent_client_secret = props.payment_intent_client_secret;
                stripe.retrievePaymentIntent(payment_intent_client_secret)
                    .then(function (result) {
                    if (!result.error) {
                        if (result.paymentIntent.status === 'requires_payment_method') {
                            // Authentication failed, prompt the customer to enter another payment method
                            swal({
                                title: "確認",
                                text: "クレジットカード決済できませんでした。必要により別カードの登録をご検討ください。",
                                icon: "warning",
                                buttons: {
                                    ok: {
                                        text: "OK",
                                        className: "timeout-ok-btn",
                                    },
                                },
                            });
                            auth_3ds_complete.value = "failed";
                        }
                        if (result.paymentIntent.status === 'succeeded') {
                            // auth_3ds_complete.value = "success"
                            Inertia.get(route('question.index'), { option_type: QuestionType.MY_POSTS });
                            swal({
                                title: "決済完了",
                                text: "クレジットカード決済が完了しました。",
                                icon: "success",
                                buttons: {
                                    ok: {
                                        text: "OK",
                                        className: "timeout-ok-btn",
                                    },
                                },
                            });
                        }
                    }
                    else {
                        auth_3ds_complete.value = "failed";
                    }
                });
            }
            else {
                auth_3ds_complete.value = "success";
            }
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
                if (!props.payment) {
                    stripeBtn.value.click();
                }
            });
        }));
        return (_ctx, _cache) => {
            return (auth_3ds_complete.value !== 'loading')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _hoisted_7,
                                    _createElementVNode("form", null, [
                                        _createElementVNode("dl", null, [
                                            _hoisted_8,
                                            _createElementVNode("dd", null, _toDisplayString(_unref(showCardNumber)), 1),
                                            _hoisted_9,
                                            _createElementVNode("dd", null, _toDisplayString(_unref(showLimitDate)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("a", {
                                                id: "payment-change-btn",
                                                class: "bt_change modal_win",
                                                "data-target": "payment-modal",
                                                ref_key: "stripeBtn",
                                                ref: stripeBtn
                                            }, _toDisplayString(props.payment ? 'カードの変更' : '支払方法登録'), 513)
                                        ])
                                    ]),
                                    (!_ctx.$props.create_question_available)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _hoisted_12,
                                            _hoisted_13,
                                            _createElementVNode("a", {
                                                style: { "margin-top": "20px" },
                                                class: "bt_change modal_win",
                                                onClick: onClickMainPlanPay
                                            }, "基本料金のお支払い")
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createVNode(StripeForm, {
                            onCompleted: onCompleted,
                            onCanceled: onCancel
                        }),
                        _createElementVNode("a", {
                            class: "bt_change modal_win",
                            "data-target": "payment-cancel-modal",
                            id: "payment-canceled",
                            ref_key: "paymentCanceled",
                            ref: paymentCanceled,
                            style: { "display": "none" }
                        }, null, 512),
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", {
                                    class: "modal-bg",
                                    onClick: onClickCancel
                                }),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", {
                                        class: "close_bt",
                                        onClick: onClickCancel
                                    }, [
                                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                    ]),
                                    _createElementVNode("div", { class: "pop" }, [
                                        _hoisted_16,
                                        _createElementVNode("div", { class: "bt_box clear" }, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "bt_clear",
                                                        onClick: onClickCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "bt_modal_close bt_ok",
                                                        onClick: onClickRegisterComplete
                                                    }, "OK")
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
